export default "__VITE_ASSET___SUjp5ln__"